<template>
  <v-app>
    <div class="w-100 topbar bg-color-1"></div>
    <View></View>
    <Footer :full="false"></Footer>
  </v-app>
</template>

<script>
import View from './View.vue';
import Footer from './Footer.vue';

export default {
  name: 'NoTemplate',
  components: {
    View,
    Footer
  },
  created() {
    document.addEventListener('gesturestart', function (e) {
      e.preventDefault();
    });
  },
}
</script>